import styles from "./styles.module.css";

const BlueButton = ({
  textValue,
  contentIcon,
  contentStartIcon,
  clickFunction,
  type = "button",
  disabled,
}) => {
  return (
    <>
      <button
        disabled={disabled}
        className={disabled ? styles.disabledButton : styles.logoutButton}
        onClick={type != "submit" ? clickFunction : null}
        type={type}
      >
        {contentStartIcon}
        <span>{textValue}</span>
        {contentIcon}
      </button>
    </>
  );
};

export default BlueButton;
